module.exports = __webpack_public_path__ + "img/svg_tax.17ed1a45.svg";